<template>
<div style="font-size: 1rem;">
  <b-row class="text-center m-auto">
    <b-col cols="3" class="border px-0 py-4 py-sm-2">
      <div class="cell-div"><span>
	<slot name="row-title"></slot>
      </span></div>
    </b-col>
    <b-col cols="1" class="border px-0 py-4 py-sm-2">
      <div class="cell-div"><span>
	<slot name="dealership"></slot>
      </span></div>
    </b-col>
    <b-col cols="2" class="border px-0 py-4 py-sm-2">
      <div class="cell-div"><span>
	<slot name="stadium"></slot>
      </span></div>
    </b-col>
    <b-col cols="2" class="border px-0 py-4 py-sm-2">
      <div class="cell-div"><span>
	<slot name="office"></slot>
      </span></div>
    </b-col>
    <b-col cols="2" class="border px-0 py-4 py-sm-2">
      <div class="cell-div"><span>
	<slot name="highrise"></slot>
      </span></div>
    </b-col>
    <b-col cols="1" class="border px-0 py-4 py-sm-2">
      <div class="cell-div"><span>
	<slot name="data-center"></slot>
      </span></div>
    </b-col>
    <b-col cols="1" class="bg-light px-0 py-4 py-sm-2">
      <div class="cell-div"><span></span></div>
    </b-col>
  </b-row>
</div>
</template>

<script>
export default {
    name: 'ProductsMetaTableRow'
}
</script>

<style scoped>
@media (max-width:576px) {
    .cell-div {
	transform: rotateZ(-90deg);
    }
}
</style>


